import type { ApiEffect } from '../../index.h'
import type {
  ICreateProfile,
  IProfile,
  IProfileSummary,
  IRemoveProfile,
} from '../../interfaces/profiles'

import { createEffect } from 'effector'

//GET /v3/profiles/summary
export const getProfilesSummaryFx: ApiEffect<void, IProfileSummary> =
  createEffect()

//GET /v3/profiles
export const getProfilesFx: ApiEffect<void, IProfileSummary> = createEffect()

//GET /v3/profiles/active
export const getActiveProfileFx: ApiEffect<void, IProfile> = createEffect()

//DELETE /v3/profiles/{profileId}
export const removeProfileFx: ApiEffect<IRemoveProfile, void> = createEffect()

//PATCH /v3/profiles/{profileId}/active
export const updateProfileActiveStateFx: ApiEffect<number, void> =
  createEffect()

//POST /v3/profiles/{profileId}/active
export const createProfileFx: ApiEffect<
  ICreateProfile,
  Pick<IProfile, 'id'>
> = createEffect()

//PUT /v3/profiles/{profileId}/active
export const updateProfileFx: ApiEffect<IProfile, void> = createEffect()
